import API from "./baseApi";

const getSubServices = (payload) => {
  return API.post("/services/subservices/get", payload);
};

const createSubServices = (payload) => {
  return API.post(`services/subservices`, payload);
};

const createSubServiceMapping = (payload) => {
  return API.post(`services/subservices/createSubServiceMapping`, payload);
};

const deleteSubServiceMapping = (payload) => {
  return API.post(`services/subservices/deleteSubServiceMapping`, payload);
};
const updateSubServiceType = (payload) => {
  return API.post(`services/subservice/updateType`, payload);
};


export default {
  getSubServices,
  createSubServices,
  createSubServiceMapping,
  deleteSubServiceMapping,
  updateSubServiceType,
};
